import { Record, List } from "immutable";
import type { RecordOf } from "immutable";
import {
  ACCOUNT_CHANGE_USERS,
  ADD_ACCOUNT_USER,
  REMOVE_ACCOUNT_USER,
  CHANGE_ACCOUNT_USER_ROLE,
} from "../../helpers/constants";
import type {
  Actions, ChangeUsersAction, AddAccountUserAction, RemoveAccountUserAction, ChangeAccountUserRoleAction,
} from "../../actions/accountUsers";
import type { User } from "../../pages/EditAccount";

export type DefaultState = {
  users: List<User>,
}

const defaultValues: DefaultState = {
  users: List([]),
};

export const makeState = Record(defaultValues);

export type State = RecordOf<DefaultState>;

export const initialState: State = makeState({});

export function initSetupAccountUsersState(): State {
  return initialState;
}

// eslint-disable-next-line default-param-last
const accountUsersReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ACCOUNT_CHANGE_USERS: {
      const { value } = action as ChangeUsersAction;
      return state.withMutations((newState) => {
        newState.setIn(["users"], List(value));
      });
    }
    case ADD_ACCOUNT_USER: {
      const { value } = action as AddAccountUserAction;
      return state.withMutations((newState) => {
        newState.update("users", (users) => users.push(value));
      });
    }
    case REMOVE_ACCOUNT_USER: {
      const { userId } = action as RemoveAccountUserAction;
      return state.withMutations((newState) => {
        const users = newState.get("users");
        const index = users.findIndex(({ id }) => (id === userId));
        if (index !== -1) {
          newState.deleteIn(["users", index]);
        }
      });
    }
    case CHANGE_ACCOUNT_USER_ROLE: {
      const { userId, value } = action as ChangeAccountUserRoleAction;
      return state.withMutations((newState) => {
        const users = newState.get("users");
        const index = users.findIndex(({ id }) => (id === userId));
        newState.setIn(["users", index, "role"], value);
      });
    }
    default:
      return state;
  }
};

export default accountUsersReducer;
